import React, { useContext, useState } from 'react';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import SecurityAdvisorContext from 'src/context/SecurityAdvisorContext';
import { Slider, Tag, Button, notification, Alert, Space } from 'antd';
import { patchJob } from 'src/api/securityAdvisor';

const FineTuningSecurity = () => {
  const { executeAsyncProcess } = useAsyncProcesses();
  const { job, updateJob } = useContext(SecurityAdvisorContext);
  const [options, setOptions] = useState([
    {
      id: 'oauthNotUsed',
      name: 'Stale Oauth Clients',
      value: job?.score_settings?.oauthNotUsed || job?.score_settings?.oauthNotUsed === 0 ? job?.score_settings?.oauthNotUsed : 10,
      default: 10,
    },
    {
      id: 'usersNotLogged',
      name: 'Users Not Logged In',
      value: job?.score_settings?.usersNotLogged || job?.score_settings?.usersNotLogged === 0 ? job?.score_settings?.usersNotLogged : 5,
      default: 5,
    },
    {
      id: 'sessionTimeout',
      name: 'Session Timeout',
      value: job?.score_settings?.sessionTimeout || job?.score_settings?.sessionTimeout === 0 ? job?.score_settings?.sessionTimeout : 10,
      default: 10,
    },
    {
      id: 'encryptionKeys',
      name: 'Encryption Keys',
      value: job?.score_settings?.encryptionKeys || job?.score_settings?.encryptionKeys === 0 ? job?.score_settings?.encryptionKeys : 4,
      default: 4,
    },
    {
      id: 'selfInviteLink',
      name: 'Self Invite Link',
      value: job?.score_settings?.selfInviteLink || job?.score_settings?.selfInviteLink === 0 ? job?.score_settings?.selfInviteLink : 0,
      default: 0,
    },
    {
      id: 'passwordRequirements',
      name: 'Password Requirements',
      value: job?.score_settings?.passwordRequirements || job?.score_settings?.passwordRequirements === 0 ? job?.score_settings?.passwordRequirements : 10,
      default: 10,
    },
    {
      id: 'ipAddressAllowlist',
      name: 'IP Address Allowlist',
      value: job?.score_settings?.ipAddressAllowlist || job?.score_settings?.ipAddressAllowlist === 0 ? job?.score_settings?.ipAddressAllowlist : 3,
      default: 3,
    },
    {
      id: 'emebeddableDomainList',
      name: 'Emebeddable Domain List',
      value: job?.score_settings?.emebeddableDomainList || job?.score_settings?.emebeddableDomainList === 0 ? job?.score_settings?.emebeddableDomainList : 3,
      default: 3,
    },
    {
      id: 'hipaa',
      name: 'HIPAA',
      value: job?.score_settings?.hipaa || job?.score_settings?.hipaa === 0 ? job?.score_settings?.hipaa : 0,
      default: 0,
    },
    {
      id: 'pci',
      name: 'PCI',
      value: job?.score_settings?.pci || job?.score_settings?.pci === 0 ? job?.score_settings?.pci : 3,
      default: 3,
    },
    {
      id: 'notTlsTrunks',
      name: 'Not TLS Trunks',
      value: job?.score_settings?.notTlsTrunks || job?.score_settings?.notTlsTrunks === 0 ? job?.score_settings?.notTlsTrunks : 10,
      default: 10,
    },
  ]);

  if (!job) return null;

  const handleOptionUpdate = (id, value) => {
    console.log('handleOptionUpdate:', id, value);
    let myOptions = [...options];
    myOptions.find((o) => o.id === id).value = value;
    setOptions(myOptions);
  };

  const handleSaveOptions = async (e) => {
    await executeAsyncProcess(async () => {
      try {
        const changes = { score_settings: {} };
        options.forEach((option) => {
          changes.score_settings[option.id] = option.value;
        });

        updateJob(changes);
        await patchJob(job.id, changes);

        notification.success({
          message: 'Success',
          description: 'Job has been updated',
          duration: 5,
        });
      } catch (error) {
        console.log(error);
      }
    });
  };

  const handleRestoreDef = async (e) => {
    await executeAsyncProcess(async () => {
      try {
        const changes = { score_settings: {} };
        options.forEach((option) => {
          changes.score_settings[option.id] = option.default;
          option.value = option.default;
        });

        updateJob(changes);
        await patchJob(job.id, { score_settings: {} });

        notification.success({
          message: 'Success',
          description: 'Settings restored to default',
          duration: 5,
        });
      } catch (error) {
        console.log(error);
      }
    });
  };

  const msg = (
    <span className='text-xs'>
      Set security settings according to your needs. <br />
      Each section represents a different security aspect. <br />
      Move the slider to adjust the security score. <br />
      The higher the value, more important the aspect is.
    </span>
  );

  return (
    <div>
      <p className='mb-4'>
        <Alert message={msg} type='info' />
      </p>
      <div className='flex flex-auto mb-4'>
        <span className='flex flex-auto text-left text-xl'>
          <Tag color='darkGreen'>0- Low</Tag>
        </span>
        <span className='text-right'>
          <Tag color='red'>10 - High</Tag>
        </span>
      </div>

      <div className='p-2'>
        {options.map((option, id) => (
          <div key={id}>
            {option.name}
            <Slider key={option.id} value={option.value} min={0} max={10} onChange={(value) => handleOptionUpdate(option.id, value)} />
          </div>
        ))}
      </div>
      <div className='relative w-full'>
        <Space>
          <Button className='' onClick={handleRestoreDef}>
            Restore to Default
          </Button>
          <Button type='primary' className='absolute inset-y-0 right-0' onClick={handleSaveOptions}>
            Save
          </Button>
        </Space>
      </div>
    </div>
  );
};

FineTuningSecurity.propTypes = {};

export default FineTuningSecurity;
